import axios from 'axios'
import moment from 'moment'
import Vue from 'vue'

const stores = {
  state: {
    info: {},
    storesList: [],
    payments: [],
    groupList: [],
    storeSelected:"",
    groupSelected:"",
    paymentsContract: {
      data: [],
      timestamp: moment().unix()
    },
    monthlyPayments:{
      data: [],
      timestamp: moment().unix()
    },
    paymentsOptions: []
  },
  mutations: {
    SET_STORE_INFO (state, data) {
      state.info = data
    },
    SET_STORES_LIST (state, data) {
      state.storesList = data
    },
    SET_GROUP_LIST (state, data) {
      state.groupList = data
    },
    SET_STORE_SELECTED (state, data) {
      state.storeSelected = data
    },
    SET_GROUP_SELECTED (state, data) {
      state.groupSelected = data
    },
    SET_STORE_PAYMENTS (state, data) {
      state.payments = Array.from(new Set(data))
      let colors = [
        '#e2dacf',
        '#ffe800',
        '#71c6c1',
        '#5482ab',
        '#6e2585',
        '#bd1d65',
        '#e1306c',
        '#cc0000',
        '#123962'
      ]
      let counter = 0
      state.paymentsOptions = state.payments.map(item => {
        let obj = {}
        obj.name = item
        obj.title = ''
        obj.selected = true
        switch (item) {
          case 'applepay':
            obj.color = '#59585a'
            break
          case 'linepay':
            obj.color = '#97c464'
            break
          case 'samsungpay':
            obj.color = '#235c97'
            break
          case 'credit':
            obj.color = '#fed53a'
            break
          case 'googlepay':
            obj.color = '#c5d340'
            break
          case 'piapp':
            obj.color = '#1aadc7'
            break
          case 'ipass':
            obj.color = '#e4690e'
            break
          case 'easycard':
            obj.color = '#089082'
            break
          default:
            obj.color = colors[counter]
            counter++
            break
        }
        return obj
      })
    },
    SET_STORE_PAYMENTS_DETAIL (state, data) {
      state.paymentsContract.data = data
      state.paymentsContract.timestamp = moment().unix()
    },
    SET_STORES_CONTRACT_PAYMENT (state, data) {
      state.monthlyPayments.data = data
      state.monthlyPayments.timestamp = moment().unix()
    },
    REMOVE_STORE_INFO (state) {
      Object.keys(state.info).forEach(item => {
        switch (typeof state.info[item]) {
          case 'string':
            state.info[item] = ''
            break
          case 'number':
            state.info[item] = 0
            break
          case 'object':
            state.info[item] = {}
            break
          default:
            if (Array.isArray(state.info[item])) {
              state.info[item] = []
            }
        }
      })
      state.payments = []
      state.storesList = []
      state.paymentsContract = {
        data: [],
        timestamp: moment().unix()
      }
    }
  },
  actions: {
    fetchStoreInfo ({commit, dispatch}, {params}) {
      return new Promise((resolve, reject) => {
        axios.get('/api/v1/stores', {params: params})
          .then(response => {
            commit('SET_STORES_LIST', response.data)
            // 先取第一間為主要店家，等待ＳＰＥＣ更新多店規格
            commit('SET_STORE_INFO', response.data[0])
            resolve(response)
          })
          .catch(error => {
            dispatch('errorsHandler', {params: error})
            // reject(error)
          })
      })
    },
    fetchGroups ({commit, dispatch}, {params}) {
      return new Promise((resolve, reject) => {
        axios.get('/api/v1/groups', {params: params})
          .then(response => {
            commit('SET_GROUP_LIST', response.data)
            resolve(response)
          })
          .catch(error => {
            dispatch('errorsHandler', {params: error})
           // reject(error)
          })
      })
    },
    fetchPaymentsContract ({commit, dispatch}) {
      return new Promise((resolve, reject) => {
        axios.get('/api/v1/stores/payments/detail')
          .then(response => {
            // 計算 當月是否超過額度
            let creditsType = ['credit', 'installment', 'point', 'applepay', 'googlepay', 'samsungpay']
            let creditIndexs = []
            let payments = response.data.payments.dataSets
            let contracts = response.data.contracts
            let storeId = contracts[0] && contracts[0].storeId
            let creditObj = contracts[0] && contracts[0].monthlyCreditLimits.find(item => item.category === 'credit')
            creditsType.forEach(type => {
              let findIndex = payments.paymentMethods.findIndex(item => item === type)
              if (findIndex >= 0) creditIndexs.push(findIndex)
            })
            let total = payments.chartSource.reduce((result, val) => {
              return result + creditIndexs.reduce((subResult, item) => subResult + val.usedCredits[item], 0)
            }, 0)
            if (creditObj) {
              let limitPercent = 0
              if(creditObj.creditLimit === 0){
                limitPercent = 0
              }else{
                limitPercent = Math.floor(total / creditObj.creditLimit * 100)
              }
              let limitScope = 0
              if (limitPercent >= 100) {
                limitScope = 100
              } else if (limitPercent < 100 && limitPercent >= 95) {
                limitScope = 95
              } else if (limitPercent < 95 && limitPercent >= 90) {
                limitScope = 90
              } else if (limitPercent < 90 && limitPercent >= 80) {
                limitScope = 80
              }
              if (limitScope !== 0) {
                switch (limitScope) {
                  case 100:
                    commit('SET_QUOTA_MODAL_STATUS', {status: true, type: 'over'})
                    break
                  case 95:
                  case 90:
                  case 80:
                    if (storeId) {
                      let quotaRecord = JSON.parse(window.localStorage.getItem(storeId + '_credit_quota'))
                      if (!quotaRecord || quotaRecord.level !== limitScope) {
                        commit('SET_QUOTA_MODAL_STATUS', {status: true, type: 'limit', level: limitScope})
                        window.localStorage.setItem(storeId + '_credit_quota', JSON.stringify({level: limitScope}))
                      }
                    }
                    break
                }
              }
            }
            if (contracts[0]) {
              let allPayments = Array.from(new Set(contracts[0].contractPayments.map(item => item.paymentMethod)))
              // console.log(allPayments)
              // commit('SET_STORE_PAYMENTS', payments.paymentMethods)
              commit('SET_STORE_PAYMENTS', allPayments)
            }
            commit('SET_STORE_PAYMENTS_DETAIL', contracts)
            commit('SET_STORES_CONTRACT_PAYMENT', payments)
            resolve(response)
          })
          .catch(error => {
            dispatch('errorsHandler', {params: error})
            // 避免讀取合約明細失敗造成web無法繼續進行，填入預設值繼續進行
            commit('SET_STORE_PAYMENTS', [])
            commit('SET_STORE_PAYMENTS_DETAIL', [])
            commit('SET_STORES_CONTRACT_PAYMENT', [])
            resolve()
          })
      })
    }
  },
  getters: {
    getStoresInfo (state) {
      return state.info
    },
    getGroupsList (state) {
      return state.groupList
    },
    getStoreList (state) {
      return state.storesList
    },
    getStoresAllPayments (state) {
      return state.paymentsOptions
    },
    isMultiStore (state) {
      return state.storesList.length > 1
    },
    getPaymentsContract (state) {
      let result = state.paymentsContract.data
      // for test
      // if (result[0]) result[0].contractPayments = result[0].contractPayments.filter(item => item/* && item.txnChannel !== 'offline' */).slice()
      return result
    },
    getStoresContractPayment(state){
      return state.monthlyPayments.data
    },
    getPaymentsContractTime (state) {
      return state.paymentsContract.timestamp
    }
  }
}

export default stores
